var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetryRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M12.5122 4.02129L13.2722 3.26129C13.5476 2.96578 13.5395 2.50528 13.2539 2.21967C12.9682 1.93406 12.5077 1.92593 12.2122 2.20129L10.2122 4.20129C9.91978 4.49411 9.91978 4.96847 10.2122 5.26129L12.2122 7.26129C12.505 7.55375 12.9794 7.55375 13.2722 7.26129C13.5647 6.96847 13.5647 6.49411 13.2722 6.20129L12.6122 5.54129C15.9796 5.95841 18.6039 8.66112 18.9217 12.0393C19.2395 15.4175 17.1653 18.5622 13.9347 19.6C10.7042 20.6378 7.18665 19.2894 5.47757 16.3581C3.76849 13.4269 4.32777 9.70148 6.82223 7.40129C7.06396 7.11386 7.05582 6.69195 6.80319 6.41405C6.55056 6.13616 6.13133 6.08797 5.82223 6.30129C2.78041 9.1031 2.11554 13.6519 4.2282 17.2071C6.34086 20.7623 10.6541 22.353 14.5692 21.0207C18.4842 19.6884 20.9319 15.797 20.4375 11.6911C19.9431 7.58524 16.6417 4.38614 12.5222 4.02129H12.5122Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryRefresh);
export default __webpack_public_path__ + "static/media/Retry-refresh.0a3fd28c.svg";
export { ForwardRef as ReactComponent };